// Public types + helpers shared by useJobStream's three transport layers.

import { supabase } from '@/lib/supabase';

export interface JobEvent {
  event_type: string;
  agent_name: string;
  timestamp: string;
  progress_pct: number;
  message: string;
  job_id: string;
}

export interface JobStreamState {
  status: string | null;
  progress: number;
  events: JobEvent[];
  isConnected: boolean;
  error: string | null;
  layer: 'ws' | 'sse' | 'poll' | null;
}

export const POLL_INTERVAL_MS = 5_000;
export const MAX_RETRIES = 3;
export const RETRY_BASE_MS = 1_000;
export const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '';

/** Resolve the current Supabase access token via the live SDK session.
 *
 * The previous implementation read from `localStorage['supabase.auth.token']`,
 * which is the v1 key. supabase-js v2 stores under
 * `sb-<project>-auth-token`, so v1-style reads always returned '' and the
 * polling layer of useJobStream silently sent unauth'd requests.
 */
export async function getToken(): Promise<string> {
  try {
    const { data } = await supabase.auth.getSession();
    return data.session?.access_token ?? '';
  } catch {
    return '';
  }
}
